module.exports = __webpack_public_path__ + "static/assets/b52b83f63e8482255d46f40ea454fa01.mp3";